require('new_design/common/page');
